"use client";

import { useEffect } from "react";
import { reportClientError } from "@/components/ClientErrorReporter";

// Tampilkan penyebab crash yang SEBENARNYA di layar, bukan
// "Application error: a client-side exception has occurred".
export function ErrorDetails({
  error,
  reset,
  where,
}: {
  error: Error & { digest?: string };
  reset: () => void;
  where: string;
}) {
  useEffect(() => {
    reportClientError({
      kind: "react.error-boundary",
      where,
      message: error?.message ?? String(error),
      digest: error?.digest ?? null,
      stack: error?.stack ?? null,
    });
  }, [error, where]);

  return (
    <div style={{ padding: 24, fontFamily: "ui-monospace, monospace", color: "#111" }}>
      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
        Ethan AI — terjadi error di halaman ini
      </h2>
      <p style={{ marginBottom: 12, fontSize: 13 }}>
        Screenshot layar ini dan kirim ke admin. Detail teknis:
      </p>
      <pre
        style={{
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          background: "#f6f6f6",
          border: "1px solid #ddd",
          borderRadius: 8,
          padding: 12,
          fontSize: 12,
          maxHeight: "60vh",
          overflow: "auto",
        }}
      >
{`where:   ${where}
message: ${error?.message ?? String(error)}
digest:  ${error?.digest ?? "-"}
stack:
${error?.stack ?? "-"}`}
      </pre>
      <button
        onClick={() => reset()}
        style={{
          marginTop: 12,
          padding: "8px 16px",
          borderRadius: 8,
          border: "1px solid #7c3aed",
          background: "#7c3aed",
          color: "#fff",
          cursor: "pointer",
        }}
      >
        Coba lagi
      </button>
    </div>
  );
}
